import * as R from 'ramda';

import generateId from '../../utils/generateId';

const overrideFilters =
    () =>
    (state, filters, overridingFiltersElement = []) => {
        const userClientId = state.user.selectedUserClientId;
        return R.evolve(
            {
                clients: {
                    [userClientId]: {
                        filters: {
                            overridesId: R.always(generateId()),
                        },
                        media: {
                            filtersOverride: R.always(filters),
                            overridingFiltersElement: R.always(
                                overridingFiltersElement,
                            ),
                        },
                        broadcasts: {
                            filtersOverride: R.always(filters),
                            overridingFiltersElement: R.always(
                                overridingFiltersElement,
                            ),
                        },
                    },
                },
            },
            state,
        );
    };

export default overrideFilters;
